import { Price } from "@/components/marketplace/product/price"
import { Text } from "@/components/ui"
import { TileImage } from "@/components/ui/tile-image"
import type { Result as SearchProduct } from "@/generated/api/types.gen"
import { DEFAULT_CURRENCY, moneyFromNumber } from "@/lib/money"

export const SearchProductOption = ({ product }: { product: SearchProduct }) => {
  const amount = product.reducedPrice ?? product.price
  const was = product.reducedPrice != null ? (product.price ?? undefined) : undefined

  return (
    <div className="flex min-w-0 flex-1 items-center gap-300">
      <div className="bg-surface-page rounded-4x relative size-11 shrink-0 overflow-hidden">
        <TileImage src={product.icon.imageUrl ?? ""} alt={product.name} fill sizes="44px" className="object-contain" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-50">
        <Text as="span" variant="bodySm" family="text" tone="default" className="line-clamp-2 font-medium">
          {product.name}
        </Text>
        {amount != null && <Price amount={moneyFromNumber(amount, DEFAULT_CURRENCY)} was={was != null ? moneyFromNumber(was, DEFAULT_CURRENCY) : undefined} size="sm" exact />}
      </div>
    </div>
  )
}
